import React, { useState, useEffect } from 'react';
import '../styles/YouTubeDownloader.css';

const YouTubeDownloader: React.FC = () => {
  const [url, setUrl] = useState('');
  const [type, setType] = useState('video');
  const [format, setFormat] = useState('mp4');

  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const handleDownload = () => {
    if (!url) {
      alert('Insira um link válido');
      return;
    }
    const endpoint = `http://localhost:3000/download?url=${encodeURIComponent(url)}&type=${type}&format=${format}`;
    window.open(endpoint, '_blank');
  };

  return (
    <div className="youtube-downloader">
      <h2>Baixar Vídeo ou Áudio do YouTube</h2>

      <input
        type="text"
        placeholder="Cole o link do YouTube aqui"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        className="input-url"
      />

      <div className="controls">
        <div>
          <label>Tipo:</label>
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="video">Vídeo</option>
            <option value="audio">Áudio</option>
          </select>
        </div>

        <div>
          <label>Formato:</label>
          <select value={format} onChange={(e) => setFormat(e.target.value)}>
            {type === 'video' ? (
              <>
                <option value="mp4">MP4</option>
                <option value="webm">WebM</option>
              </>
            ) : (
              <>
                <option value="mp3">MP3</option>
                <option value="m4a">M4A</option>
              </>
            )}
          </select>
        </div>
      </div>

      <button onClick={handleDownload} className="download-btn">Baixar</button>

      {/* Google AdSense */}
      <div className="ad-container">
        <ins className="adsbygoogle"
             style={{ display: 'block' }}
             data-ad-client="ca-pub-1989683361613000"
             data-ad-slot="1234567890"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>
    </div>
  );
};

export default YouTubeDownloader;
